import { initializeApp } from 'firebase/app';
/*
  Need to create a file called firebaseConfig.js
  in the same folder as this file and export the firebaseConfig
*/
import { firebaseConfig } from './firebaseConfig';

const app = initializeApp(firebaseConfig);

export { app };
